import actionTypes from '../constants/action-types';
import setScrollStatus from '../actions/set-scroll-status';
import getScrollStatus from '../selectors/scroll-status';

const TIME_TO_FINISH_SCROLL = 250;
let scrollEndTimer;

const scroll = (store) => (next) => (action) => {
  if (action.type === actionTypes.SET_SCROLL_POSITION) {
    const state = store.getState();
    const isScrolling = getScrollStatus(state);

    if (!isScrolling) {
      store.dispatch(setScrollStatus(true));
    }

    clearTimeout(scrollEndTimer);
    scrollEndTimer = setTimeout(() => {
      store.dispatch(setScrollStatus(false));
    }, TIME_TO_FINISH_SCROLL);
  }

  next(action);
};

export default scroll;
